export const getTalentRatioColor = (talentRatio: number) => {
  if (talentRatio === 0) {
    return 'gray';
  }

  if (talentRatio === 100) {
    return 'darkGray';
  }

  if (talentRatio < 50) {
    return 'darkRed';
  }

  if (talentRatio < 100) {
    return 'lightRed';
  }

  if (talentRatio < 200) {
    return 'lightGreen';
  }

  return 'darkGreen';
};
